<script lang="ts">
  import type { RequestBuilder } from "@lernetz/request";
  import { t } from "@lernetz/svelte-translate";
  import { onMount } from "svelte";
  import { intersect } from "svelte-intersection-observer-action";

  export let request: RequestBuilder;
  export let vars: Record<string, any> = {};

  export let breakpoints: Record<number, Record<string, any>> = {};
  export let placeholder: Record<string, any> = {};
  export let relativeToParent: boolean = true;
  export let threshold: number = 0.25;

  let img: HTMLImageElement;
  let isLoaded: boolean = false;

  onMount(() => {
    img.addEventListener("error", errorHandler);
  });

  function placeholderUrl() {
    return request.vars({ ...vars, ...placeholder }).url;
  }

  function imageUrl() {
    let breakpoint = calculateBreakpoint();
    return request.vars({ ...vars, ...breakpoint }).url;
  }

  function calculateBreakpoint() {
    let breakpoint: Record<string, string>;
    let sizes = Object.keys(breakpoints).sort();
    let compareElement = relativeToParent ? img.parentElement : document.documentElement;
    let w = compareElement.clientWidth * window.devicePixelRatio;

    sizes.forEach((key) => {
      if (w <= Number.parseInt(key)) {
        breakpoint = breakpoints[key];
      }
    });

    return breakpoint;
  }

  function errorHandler() {
    let breakpoint = calculateBreakpoint();
    let width = Math.round(vars?.width || breakpoint?.width || 300);
    let height = Math.round(width / 1.333);
    setImage(`https://placehold.co/${width}x${height}?text=${$t("image-error")}`);
  }

  function setImage(url) {
    if (url !== img.getAttribute("src")) img.setAttribute("src", url);
  }

  function intersectHandler(entry: IntersectionObserverEntry) {
    // check if the image was already loaded - then nothing is todo
    if (isLoaded) return;

    // only set placeholder if not visible and not already loaded
    if (entry.intersectionRatio <= threshold) {
      setImage(placeholderUrl());
    } else {
      isLoaded = true;
      setImage(imageUrl());
    }
  }
</script>

<!-- svelte-ignore a11y-missing-attribute -->
<img
  use:intersect={{ callback: intersectHandler, threshold: threshold }}
  bind:this={img}
  {...$$restProps}
/>
